// extracted by mini-css-extract-plugin
module.exports = {"breakpointMD":"750px","breakpointLG":"1250px","breakpointXL":"1800px","button":"Button-module--button--2vO6V","loading":"Button-module--loading--1HeLX"};